import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuditCollectionResult } from '../models/Audits/audit-collection-result';
import { AuditResult } from '../models/Audits/audit-result';
import { AuditRequest } from '../models/Audits/audit-request';
import { LocalStorageService } from './local-storage.service';
import { FlattenedQuestionHolder } from '../models/Audits/flattened-question-holder';
import { BasicResult } from '../models/basic-result';
import { AuditHolder } from '../models/Audits/audit-holder';
import { AuditTypeResult } from '../models/AuditTypes/audit-type-result';
import { AuditLocation } from '../models/Locations/audit-location';
import { UserLocationSave } from '../models/user-location-save';
import { QuestionAttachment } from '../models/Audits/question-attachment';
import { ActionResult } from '../models/Compliance-Actions/action-result';
import { DDLResult } from '../models/ddl-result';
import { BasicAuditResult } from '../models/Audits/AuditResults/basic-audit-result';
import { SupportRequest } from '../models/CustomerSupport/support-request';
import { ActionFiltersResult } from '../models/Compliance-Actions/action-filters-result';
import { Observable, catchError, map, tap, of, switchMap } from 'rxjs';
import { BackupAudit } from '../models/Audits/backup-audit';
import { SavedAuditsResult } from '../models/Audits/saved-audits-result';
import { AuditGuidService } from './audits/audit-guid.service';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  constructor(private httpClient: HttpClient, private localStorageService: LocalStorageService) { }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: "response" as "response",
    responseType: "json" as const,
    withCredentials: true
  };

  httpUploadOptions = {
    withCredentials: true,
    reportProgress: true,
    observe: 'events' as 'events'
  };

  httpDownloadOptions = {
    withCredentials: true,
    observe: 'response' as const,
    responseType: 'blob' as const
  };
  /*getAudits():Observable<Audit[]>{
    let a = [
      {AuditID: 1, AuditName: "Audit 1", AuditDescription: "This is audit 1"},
      {AuditID: 2, AuditName: "Audit 2", AuditDescription: "This is audit 2"},
      {AuditID: 3, AuditName: "Audit 3", AuditDescription: "This is audit 3"},
    ]
    return of(a);
  }*/
  getAudits(ShowInternal: boolean = true): Observable<AuditCollectionResult> {
    return this.httpClient.post<AuditCollectionResult>(`${environment.apiUrl}audits/auditlist`, ShowInternal, this.httpOptions).pipe(
      map((res: any) => {
        return new AuditCollectionResult(res.body!);
      })
    );
  }
  getEditAudits(): Observable<AuditCollectionResult> {
    return this.httpClient.get<AuditCollectionResult>(`${environment.apiUrl}audits/editauditlist`, this.httpOptions).pipe(
      map((res: any) => {
        return new AuditCollectionResult(res.body!);
      })
    );
  }
  getRemovedAudits(): Observable<AuditCollectionResult> {
    return this.httpClient.get<AuditCollectionResult>(`${environment.apiUrl}audits/removedauditlist`, this.httpOptions).pipe(
      map((res: any) => new AuditCollectionResult(res.body!))
    );
  }
  getAudit(AuditID: number, LocationID: number): Observable<AuditResult> {
    return this.httpClient.post<AuditResult>(`${environment.apiUrl}audits/getaudit`, new AuditRequest(AuditID, true, LocationID), this.httpOptions).pipe(
      map((res: any) => {
        return new AuditResult(res.body!);
      })
    );
  }
  getLocalAudits(): Observable<UserLocationSave[]> {
    this.localStorageService.loadData(1);
    var username = '';
    this.localStorageService.observables.localRef.find(e => { return e.ID == "userSettings" })?.Obs.pipe(tap((f: any) => {
      if (f != null) {
        username = f.Username.toLowerCase();
      }
    })).subscribe();
    var returnAudits: UserLocationSave[] = [];
    this.localStorageService.loadData(2);
    this.localStorageService.observables.localRef.find(e => { return e.ID == "careAudits" })?.Obs.pipe(tap((f: any) => { if (f != null) { returnAudits = f } })).subscribe();

    returnAudits = returnAudits.filter(e => e.Username.toLowerCase() == username.toLowerCase());
    return of(returnAudits);

  }
  setLocalAuditGUIDs() {
    var fullAuditList: UserLocationSave[] = [];
    this.getALLLocalAudits().pipe(tap((a: any) => {
      a.forEach((e: any) => {
        fullAuditList.push(new UserLocationSave(e))
      });
    })).subscribe();
    fullAuditList.forEach(e => {
      if (e.AuditGUID == null || e.AuditGUID.length == 0) {
        e.AuditGUID = crypto.randomUUID();
      }
    })
    this.localStorageService.setData(2, fullAuditList);
  }
  getALLLocalAudits(): Observable<UserLocationSave[]> {
    var returnAudits: UserLocationSave[] = [];
    this.localStorageService.loadData(2);
    this.localStorageService.observables.localRef.find(e => { return e.ID == "careAudits" })!.Obs.pipe(tap((f: any) => {
      if (f != null) {
        returnAudits = f;
      }
    })).subscribe();
    return of(returnAudits);

  }
  getLocalAudit(auditID: number, locationID: number, username: string): UserLocationSave {
    var ULS = new UserLocationSave();
    this.getALLLocalAudits().pipe(tap(
      (f: any) => {
        f.forEach((e: UserLocationSave) => {
          var temp = new UserLocationSave(e);
          if (temp.FlattenedQuestions[0].AuditID == auditID && temp.Location.LocationID == locationID && temp.Username == username) {
            ULS = temp;
          }
        })
      }

    )).subscribe();


    /*this.getLocalAudits().pipe().forEach(f => {
      f.forEach((e: UserLocationSave) => {
        var temp = new UserLocationSave(e);
        if (temp.FlattenedQuestions[0].AuditID == auditID && temp.Location.LocationID == locationID && temp.Username == username) {
          ULS = temp;
        }
      });
    });*/
    return ULS;
  }
  removeLocalAudit(auditGUID: string, username: string) {
    var Audits: UserLocationSave[] = [];

    this.getALLLocalAudits().pipe(
      map((f: any) => {
        let audits = f
          .filter((e: UserLocationSave) => e.AuditGUID !== auditGUID)
          .map((e: any) => new UserLocationSave(e));

        return audits;
      }),
      switchMap((audits: any) => {
        this.localStorageService.updateData(2, audits);
        return of(1);
      })
    ).subscribe();

    //
  }

  /**
   * Removes local audit copies that the API confirms have no active central save.
   * Unknown GUIDs and all local data are retained when the request fails.
   * @returns GUIDs of local audit copies removed from this device.
   */
  reconcileLocalAudits(): Observable<string[]> {
    let allLocalAudits: UserLocationSave[] = [];
    this.getALLLocalAudits().pipe(
      tap((audits: UserLocationSave[] | null) => {
        allLocalAudits = (audits ?? []).map(audit => new UserLocationSave(audit));
      })
    ).subscribe();

    let currentUserAudits: UserLocationSave[] = [];
    this.getLocalAudits().pipe(
      tap((audits: UserLocationSave[] | null) => {
        currentUserAudits = audits ?? [];
      })
    ).subscribe();

    const auditGUIDs = [...new Set(
      currentUserAudits
        .map(audit => audit.AuditGUID?.trim())
        .filter((guid): guid is string => !!guid)
    )];

    if (auditGUIDs.length === 0) {
      return of([]);
    }

    return this.httpClient.post<string[]>(`${environment.apiUrl}audits/inactiveauditguids`, auditGUIDs, this.httpOptions).pipe(
      map((res: any) => {
        const inactiveGUIDs = new Set<string>(
          (res.body ?? []).map((guid: string) => guid.toLowerCase())
        );

        if (inactiveGUIDs.size === 0) {
          return [];
        }

        const removedGUIDs = allLocalAudits
          .filter(audit => inactiveGUIDs.has((audit.AuditGUID ?? '').toLowerCase()))
          .map(audit => audit.AuditGUID);
        const retainedAudits = allLocalAudits.filter(audit =>
          !inactiveGUIDs.has((audit.AuditGUID ?? '').toLowerCase())
        );

        if (removedGUIDs.length > 0) {
          this.localStorageService.updateData(2, retainedAudits);
        }

        return removedGUIDs;
      }),
      catchError(() => of([]))
    );
  }

  saveAudit(audit: AuditHolder): Observable<ActionResult> {
    this.flattenActions(audit);
    return this.httpClient.post<ActionResult>(`${environment.apiUrl}audits/submitaudit`, audit, this.httpOptions).pipe(
      map((res: any) => {
        return res.body!;
      })
    );
  }

  submitAudit(audit: AuditHolder): string {
    return "";
  }

  getAuditTypes(): Observable<AuditTypeResult> {
    return this.httpClient.post<AuditTypeResult>(`${environment.apiUrl}lookup/audittypes`, { "CustomerID": -1, "IncludeInactive": true }, this.httpOptions).pipe(
      map((res: any) => {
        return res.body!;
      })
    );
  }

  getQuestionTypes(): Observable<AuditTypeResult> {
    return this.httpClient.post<AuditTypeResult>(`${environment.apiUrl}lookup/questiontypes`, false, this.httpOptions).pipe(
      map((res: any) => {
        return res.body!;
      })
    );
  }
  removeFile(fileName: string): Observable<BasicResult> {
    let req = JSON.stringify(fileName);
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/removeattachment`, req, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res);
      })
    );
  }
  private flattenActions(audit: AuditHolder) {
    audit.Audit.Questions.forEach(e => {
      e.CompletionInfo.Actions.forEach(f => {
        if (f.StandardAction.StandardQuestionEntryID != -1) {
          f.ActionNote = f.StandardAction.StandardEntryText;
        }
      })
    })
  }

  uploadFile(attachment: QuestionAttachment, data: File) {

    return this.httpClient.post<string>(`${environment.apiUrl}audits/saveattachment`, data, this.httpUploadOptions);
  }
  uploadPhoto(photo: string) {
    return this.httpClient.post<string>(`${environment.apiUrl}audits/savephoto`, photo, this.httpUploadOptions);
  }
  removePhoto(fileName: string): Observable<BasicResult> {
    let req = JSON.stringify(fileName);
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/removephoto`, req, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res);
      })
    );
  }
  saveAuditChanges(audit: FlattenedQuestionHolder): Observable<BasicResult> {
    let req = { Audit: audit };
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/savechanges`, req, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  deleteAudit(auditID: number): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/deleteaudit`, auditID, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  reactivateAudit(auditID: number): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/reactivateaudit`, auditID, this.httpOptions).pipe(
      map((res: any) => new BasicResult(res.body!))
    );
  }
  getAuditLocationsAuditList(): Observable<BasicAuditResult> {
    return this.httpClient.get<BasicAuditResult>(`${environment.apiUrl}audits/getauditlocationauditlist`, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicAuditResult(res.body!);
      })
    );
  }
  getAuditUsersAuditList(): Observable<BasicAuditResult> {
    return this.httpClient.get<BasicAuditResult>(`${environment.apiUrl}audits/getaudituserauditlist`, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicAuditResult(res.body!);
      })
    );
  }
  sendSupportRequest(sr: SupportRequest): Observable<BasicResult> {
    let req = new SupportRequest(sr);
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/supportrequest`, req, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  sendAutoRecovery(sr: SupportRequest): Observable<BasicResult> {
    let req = new SupportRequest(sr);
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/autosave`, sr, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  sendAuditAutoRecovery(BA: BackupAudit): Observable<BasicResult> {

    return this.httpClient.post<BasicResult>(`${environment.apiUrl}audits/autosaveaudit`, BA, this.httpOptions).pipe(
      map((res: any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  fetchAuditRecoveryAudits(): Observable<SavedAuditsResult> {

    return this.httpClient.get(`${environment.apiUrl}audits/fetchcentralaudits`, this.httpOptions).pipe(
      map((res: any) => {
        return new SavedAuditsResult(res.body!);
      })
    );
  }
  recoverAudit(SaveID: number): Observable<UserLocationSave> {
    return this.httpClient.post<number>(`${environment.apiUrl}audits/fetchcentralaudit`, SaveID, this.httpOptions).pipe(
      map((res: any) => {
        return new UserLocationSave(res.body!);
      })
    );
  }
  removeAudit(AuditGUID: string): Observable<BasicResult> {
      let req = JSON.stringify(AuditGUID);
    return this.httpClient.post<string>(`${environment.apiUrl}audits/removeaudit`, req, this.httpOptions).pipe(
      map((res: any) => {
        return new SavedAuditsResult(res.body!);
      })
    );
  }
  centralAudits():Observable<UserLocationSave[]>{

      return this.httpClient.get(`${environment.apiUrl}audits/homepageaudits`, this.httpOptions).pipe(
      map((res: any) => {
        return res.body!.map((e:any)=>{return new UserLocationSave(e)});
      })
    );
  }
  downloadAttachment(guid: string){
    return this.httpClient.get(`${environment.apiUrl}audits/getattachment/${guid}`, this.httpDownloadOptions);
  }
}
